// src/runtime/detect.ts
import type { Runtime } from "./types";

export function detectRuntime(): Runtime {
  // Check if we're in a browser environment
  if (typeof window !== "undefined" && typeof window.document !== "undefined") {
    return "client";
  }

  return "server";
}

export function isClient(): boolean {
  return detectRuntime() === "client";
}

export function isServer(): boolean {
  return detectRuntime() === "server";
}
